import React from "react";

interface EnvelopeIconProps {
  accentColor: string;
}

const SHADOW = "#0f172a";
const FLAP_FILL = "#dde2ec";
const FLAP_STROKE = "#cfd6e3";
const INTERIOR_FILL = "#e8ecf3";
const LETTER_FILL = "#ffffff";
const LETTER_STROKE = "#dfe4ec";
const CHECK_BADGE = "#4caf50";
const LETTER_LINE_STRONG = "#c5cdda";
const LETTER_LINE_SOFT = "#d8dee8";
const FRONT_FILL = "#f4f6fa";
const FRONT_STROKE = "#dfe4ec";
const FRONT_CREASE = "#e1e6ee";

const EnvelopeIcon: React.FC<EnvelopeIconProps> = ({ accentColor }) => (
  <svg
    viewBox="0 0 240 200"
    aria-hidden="true"
    focusable="false"
    style={{ width: 200, maxWidth: "100%", height: "auto" }}
    data-testid="thank-you-envelope-icon"
  >
    {/* ground shadow */}
    <ellipse cx="120" cy="188" rx="76" ry="7" fill={SHADOW} opacity="0.08" />

    {/* sparkle rays */}
    <g stroke={accentColor} strokeWidth="5" strokeLinecap="round" fill="none">
      <path d="M16 40 L30 54" />
      <path d="M8 76 L26 76" />
      <path d="M224 40 L210 54" />
      <path d="M232 76 L214 76" />
    </g>

    {/* open back flap */}
    <path
      d="M32 92 L120 22 L208 92 Z"
      fill={FLAP_FILL}
      stroke={FLAP_STROKE}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />

    {/* envelope interior */}
    <rect x="32" y="84" width="176" height="90" fill={INTERIOR_FILL} />

    {/* letter */}
    <rect
      x="72"
      y="40"
      width="96"
      height="92"
      rx="8"
      fill={LETTER_FILL}
      stroke={LETTER_STROKE}
      strokeWidth="1.5"
    />
    <circle cx="120" cy="70" r="17" fill={CHECK_BADGE} />
    <path
      d="M111 70.5 L117.5 77 L130 63.5"
      fill="none"
      stroke="#ffffff"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="92"
      y="98"
      width="56"
      height="4.5"
      rx="2.25"
      fill={LETTER_LINE_STRONG}
    />
    <rect
      x="102"
      y="108"
      width="36"
      height="4.5"
      rx="2.25"
      fill={LETTER_LINE_SOFT}
    />

    {/* envelope front */}
    <path
      d="M32 92 L120 150 L208 92 L208 168 Q208 180 196 180 L44 180 Q32 180 32 168 Z"
      fill={FRONT_FILL}
      stroke={FRONT_STROKE}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M38 176 L98 128 M202 176 L142 128"
      fill="none"
      stroke={FRONT_CREASE}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default EnvelopeIcon;
